<a
    [attr.data-btnId]="getElementId('setFocus')"
    (click)="setFocus()"
    ngbTooltip="{{ 'Focus the map on the element' | translate }}">
    <fa-icon [icon]="['fas', 'eye']"></fa-icon>
</a>
